export const adviseList = [
  {'code': 'SIGN_DOCUMENT',
    'path': 'sign-document',
  }
];